import React from 'react';
import Image from 'next/legacy/image';

import defaultFullLogo from '@/images/gl-logo-full-large.svg';

interface GreenlightLogoProps {
  className?: string;
  style?: React.CSSProperties;
  isMenuOpen?: boolean;
}

export function GreenlightLogo({ className, style }: GreenlightLogoProps) {
  return (
    <Image
      src={defaultFullLogo}
      alt="Greenlight logo"
      width={160}
      height={24}
      style={{ objectFit: 'contain', ...style }}
      className={className}
    />
  );
}
